const prod = {
    url: {
        API_ENDPOINT: "https://api.thedivash.com", // use in production
        IMG_ENDPOINT: "https://media-assets.thedivash.com",
        PG_ENDPOINT: "https://api.phonepe.com/apis/hermes/pg/v1/pay"
    }
};
const uat = {
    url: {
        API_ENDPOINT: "https://uat.api.thedivash.com", // use in production
        IMG_ENDPOINT: "https://uat.media-assets.thedivash.com",
        PG_ENDPOINT: "https://uat.api.phonepe.com/apis/hermes/pg/v1/pay"
    }
}
// Dev API host.
//
// Default: whatever host the browser is already talking to, on port 8000. Open
// the app at http://localhost:3000 and it calls http://localhost:8000; open it
// from a phone at http://192.168.8.9:3000 and it calls http://192.168.8.9:8000.
// No configuration, and nothing to go stale - the previous hardcoded literal
// pointed at a subnet this machine is no longer on.
//
// Override with REACT_APP_API_ENDPOINT in .env.development.local when the API
// lives somewhere other than the machine serving the frontend.
const DEV_API_PORT = process.env.REACT_APP_API_PORT || "8000";
const DEV_API_ENDPOINT =
    process.env.REACT_APP_API_ENDPOINT ||
    (typeof window !== "undefined" && window.location && window.location.hostname
        ? `http://${window.location.hostname}:${DEV_API_PORT}`
        : `http://127.0.0.1:${DEV_API_PORT}`);

const dev = {
    url: {
        API_ENDPOINT: DEV_API_ENDPOINT,
        IMG_ENDPOINT: "https://media-assets.thedivash.com",
        PG_ENDPOINT: "https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay",
    }
};

let configUsed = prod;
if(process.env.NODE_ENV === 'development'){
    configUsed = dev;
}
// if(window.location.origin.toLowerCase().indexOf('uat') > -1){
//     configUsed = uat;
// }
// export const config = configUsed;
// export const config = dev;
export const config = configUsed;
